import { render, staticRenderFns } from "./add-point-cateogry-modal.vue?vue&type=template&id=c32973c0&scoped=true&"
import script from "./add-point-cateogry-modal.vue?vue&type=script&lang=js&"
export * from "./add-point-cateogry-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-point-cateogry-modal.vue?vue&type=style&index=0&id=c32973c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32973c0",
  null
  
)

export default component.exports